'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FolderPropTypes } from 'DesignData/propTypes/finder';
import * as FoldersActions from 'DesignData/actions/finder/Folders';
import * as OrientationTypes from 'DesignData/enums/OrientationTypes';
import * as finderSelectors from 'DesignData/selectors/finder';
import UIFolderNav from 'UIComponents/nav/UIFolderNav';
import RootFolderDropTarget from 'DesignFinderUI/components/dnd/RootFolderDropTarget';
import FolderNode from 'DesignFinderUI/components/nav/FolderNode';
const TYPE_DEFAULT = 'default';
const TYPE_COMMAND_BAR = 'command-bar';
/**
 * @class RootFolderNav
 */

class RootFolderNav extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      isOver: false
    };

    this.handleDragOverChange = isOver => {
      this.setState({
        isOver
      });
    };
  }

  componentDidMount() {
    const {
      activeRootFolderId,
      rootFolderId
    } = this.props;

    if (activeRootFolderId && activeRootFolderId !== rootFolderId) {
      this.props.fetchContents(activeRootFolderId);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      isOver
    } = prevState;
    const {
      isOver: nextIsOver
    } = this.state;

    if (nextIsOver && nextIsOver !== isOver) {
      this.props.onUpdateCanDrop(true);
    }

    const {
      activeRootFolderId,
      rootFolderId
    } = this.props;

    if (activeRootFolderId && activeRootFolderId !== prevProps.activeRootFolderId && activeRootFolderId !== rootFolderId) {
      this.props.fetchContents(activeRootFolderId);
    }
  }

  renderDropTarget(orientation) {
    const {
      moveSelectedAssets,
      moveContents,
      activeRootFolderId
    } = this.props;
    return /*#__PURE__*/_jsx(RootFolderDropTarget, {
      folderId: activeRootFolderId,
      moveContents: moveContents,
      moveSelectedAssets: moveSelectedAssets,
      onDragOverChange: this.handleDragOverChange,
      orientation: orientation
    }, orientation);
  }

  renderDropTargets() {
    const isCommandBarType = this.props.type === TYPE_COMMAND_BAR;
    const {
      activeRootFolderId,
      rootFolderId
    } = this.props;

    if (isCommandBarType) {
      return null;
    }

    if (activeRootFolderId !== rootFolderId) {
      return /*#__PURE__*/_jsxs(Fragment, {
        children: [this.renderDropTarget(OrientationTypes.BOTTOM), this.renderDropTarget(OrientationTypes.LEFT), this.renderDropTarget(OrientationTypes.RIGHT)]
      });
    }

    return /*#__PURE__*/_jsxs(Fragment, {
      children: [this.renderDropTarget(OrientationTypes.TOP), this.renderDropTarget(OrientationTypes.BOTTOM), this.renderDropTarget(OrientationTypes.LEFT), this.renderDropTarget(OrientationTypes.RIGHT)]
    });
  }

  render() {
    if (!this.props.activeRootFolderId) {
      return null;
    }

    const isCommandBarType = this.props.type === TYPE_COMMAND_BAR;
    const itemClasses = this.state.isOver ? 'is--over-parent' : "";
    const folderNavClasses = 'root-folder-nav' + (isCommandBarType ? " is--command-bar-folder" : "");
    return /*#__PURE__*/_jsxs("div", {
      className: "root-folder-nav-container",
      children: [this.renderDropTargets(), /*#__PURE__*/_jsx(UIFolderNav, {
        "aria-label": "finder",
        className: folderNavClasses,
        depth: 0,
        children: /*#__PURE__*/_jsx(FolderNode, {
          folderId: this.props.activeRootFolderId,
          itemClassName: itemClasses,
          onUpdateCanDrop: this.props.onUpdateCanDrop,
          closeContextMenu: this.props.closeContextMenu,
          openContextMenu: this.props.openContextMenu,
          asLink: isCommandBarType,
          hideChildren: isCommandBarType
        })
      })]
    });
  }

}
/**
 * Connect
 */


RootFolderNav.propTypes = {
  moveSelectedAssets: PropTypes.func.isRequired,
  moveContents: PropTypes.func.isRequired,
  onUpdateCanDrop: PropTypes.func.isRequired,
  rootFolderId: FolderPropTypes.folderId,
  activeRootFolderId: FolderPropTypes.folderId,
  closeContextMenu: PropTypes.func.isRequired,
  openContextMenu: PropTypes.func.isRequired,
  fetchContents: PropTypes.func.isRequired,
  type: PropTypes.oneOf([TYPE_DEFAULT, TYPE_COMMAND_BAR])
};
RootFolderNav.defaultProps = {
  type: TYPE_DEFAULT
};

function mapStateToProps(state, props) {
  return {
    rootFolderId: props.rootFolderId || finderSelectors.getRootFolderId(state),
    activeRootFolderId: finderSelectors.getActiveRootFolderId(state)
  };
}

const mapDispatchToProps = {
  moveContents: FoldersActions.moveContents,
  moveSelectedAssets: FoldersActions.moveSelectedAssets,
  fetchContents: FoldersActions.fetchContents
};
/**
 * Export
 */

export default connect(mapStateToProps, mapDispatchToProps)(RootFolderNav);